import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var NoteTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(NoteTransformer, _BaseTransformer);
  var _super = _createSuper(NoteTransformer);
  function NoteTransformer() {
    _classCallCheck(this, NoteTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(NoteTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      var msg = data.message.split(":attachment:");
      var message = msg[0];
      return {
        note_id: data.note_id,
        message: message,
        attachments: data.attachments,
        created_by: data.created_by,
        created_on: data.created_on,
        sender: data.sender,
        sender_id: data.sender_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return NoteTransformer;
}(BaseTransformer);